module.exports = __webpack_public_path__ + "img/sign-get-bag.c481f6ef.png";